import React from 'react'

const iframeHtml = `
<html style="
    height: 100%;
    width: 100%;
">
    <head></head>
    <body style="
      height: 100%;
      width: 100%;
      margin: 0;
    ">
        <video style="width: 100%;height: 100%;position: absolute;background: black;" top:="" 0;="" left:="">
            <source src="static/media/src/components/Tile/mocks/video.mp4" type="video/mp4">
            Your browser doesn't support HTML5 video tag.
        </video>
    </body>
</html>`

const Iframe = ({ title = 'Video player' }) => (
  <iframe
    width="400px"
    height="225px"
    srcDoc={iframeHtml}
    title={title}
    frameBorder="0"
  />
)

export default Iframe
